module.exports = __webpack_public_path__ + "img/yx.576e9e09.png";